module.exports = __webpack_public_path__ + "img/briefcase-solid updated.fc732e63.svg";